import { IntlShape } from "react-intl"

export const TRANSACTIONS = "transactions"
export const CLIENTS = "clients"
export const UNITS = "units"
export const PRODUCTS = "products"
export const AVGTICKET = "avgTicket"
export const ITEMSPERVISIT = "itemsPerVisit"
export const ECOMMERCEREACH = "reachEcommerce"
export const TICKETREACH = "reachByTicket"
export const CLIENTREACH = "reachByClients"

export const timelineId =
	"phronesis.customerbehavior.application.customerProfiling.timeline.select."

export const options = (intl: IntlShape) => [
	{
		code: TRANSACTIONS,
		name: intl.formatMessage({ id: timelineId + TRANSACTIONS }),
	},
	{
		code: CLIENTS,
		name: intl.formatMessage({ id: timelineId + CLIENTS }),
	},
	{
		code: UNITS,
		name: intl.formatMessage({ id: timelineId + UNITS }),
	},
	{
		code: AVGTICKET,
		name: intl.formatMessage({ id: timelineId + AVGTICKET }),
	},
	{
		code: ITEMSPERVISIT,
		name: intl.formatMessage({ id: timelineId + ITEMSPERVISIT }),
	},
	{
		code: ECOMMERCEREACH,
		name: intl.formatMessage({ id: timelineId + ECOMMERCEREACH }),
	},
	{
		code: TICKETREACH,
		name: intl.formatMessage({ id: timelineId + TICKETREACH }),
	},
	{
		code: CLIENTREACH,
		name: intl.formatMessage({ id: timelineId + CLIENTREACH }),
	},
]
